import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "@/library/pages/Home";
import Levels from "@/library/pages/Levels";
import Domains from "@/library/pages/Domains";
import Indicators from "@/library/pages/Indicators";
import FilesView from "@/library/pages/FilesView";
import AdminLogin from "@/library/pages/AdminLogin";
import AdminDashboard from "@/library/pages/AdminDashboard";
import LibraryHub from "@/library/pages/LibraryHub";
import StaffLogin from "@/library/pages/StaffLogin";
import StaffDashboard from "@/library/pages/StaffDashboard";
import StaffAdmin from "@/library/pages/StaffAdmin";
import StaffActivityLog from "@/library/pages/StaffActivityLog";
import { StaffBrowse, StaffBrowseDetail } from "@/library/pages/StaffBrowse";
import "@/library/library.css";

export default function LibraryRoutes() {
  return (
    <div className="library-scope" dir="rtl">
      <Routes>
        {/* Hub is the new landing at /library */}
        <Route path="/" element={<LibraryHub />} />
        {/* Existing "school documents" library kept intact */}
        <Route path="/home" element={<Home />} />
        <Route path="/levels" element={<Levels />} />
        <Route path="/levels/:levelId" element={<Domains />} />
        <Route path="/domains/:domainId" element={<Indicators />} />
        <Route path="/indicators/:indicatorId" element={<FilesView />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/staff" element={<StaffAdmin />} />
        <Route path="/admin/staff/log" element={<StaffActivityLog />} />

        {/* New "staff documents" section */}
        <Route path="/staff/login" element={<StaffLogin />} />
        <Route path="/staff" element={<StaffDashboard />} />
        <Route path="/staff/browse" element={<StaffBrowse />} />
        <Route path="/staff/browse/:uid" element={<StaffBrowseDetail />} />
      </Routes>
    </div>
  );
}
